import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Product } from '@core/domain-classes/product';
import { PdfDataToPrint } from 'src/app/labels/labels.model';

@Component({
  selector: 'app-generate-barcode',
  templateUrl: './generate-barcode.component.html',
  styleUrls: ['./generate-barcode.component.scss'],
})
export class GenerateBarcodeComponent implements OnInit {
  @Input() product: Product;

  dataToPrint: PdfDataToPrint[] = [];

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(): void {}

  printInvoice(dataToPrint: PdfDataToPrint[]) {
    this.dataToPrint = [...dataToPrint];
    setTimeout(() => {
      let printContents, popupWin;
      printContents = document.getElementById('generateBarcode').innerHTML;
      popupWin = window.open(
        '',
        '_blank',
        'top=0,left=0,height=100%,width=auto'
      );
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title></title>
            <style>
            @page { size: auto;  margin: 0mm;  margin-top:60px; }

            @media print {
              * {
                font-family: "Hind-Vadodara", sans-serif;
                -webkit-print-color-adjust: exact;
              }
            }
            tr{
              border: 1px solid #000;
              border-spacing: 2px;
              
            }
            table {
              border-collapse: collapse;
            }
            th, td {
              padding: 5px;
            }
            </style>
            <script>
            function loadHandler(){

            var is_chrome = function () { return Boolean(window.chrome); }
        if(is_chrome)
        {
           window.print();
           setTimeout(function(){window.close();}, 1000);
           //give them 10 seconds to print, then close
        }
        else
        {
           window.print();
           window.close();
        }
        }
        </script>
          </head>
      <body onload="loadHandler()">${printContents}</body>
        </html>
    `);
      popupWin.document.close();
    }, 1000);
  }
}
